export default __webpack_public_path__ + "static/media/IconDesc_HyperTubeStackable.256.71285145.png";